var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 1.00131C10.7204 0.721309 10.3604 0.591309 10.0004 0.591309C9.64043 0.591309 9.28043 0.721309 9.00043 1.00131L5.17043 4.83131C5.06043 4.94131 4.97043 5.08131 4.93043 5.22131L4.27043 7.19131C4.17043 7.48131 4.40043 7.75131 4.67043 7.75131C4.71043 7.75131 4.76043 7.74131 4.81043 7.73131L6.78043 7.07131C6.93043 7.02131 7.06043 6.94131 7.17043 6.83131L11.0004 3.00131C11.5504 2.45131 11.5504 1.55131 11.0004 1.00131Z",
    fill: "#A9AFD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 8.43848C8.71875 9.00566 8.25469 9.46973 7.6875 9.46973H3.5625C2.99531 9.46973 2.53125 9.00566 2.53125 8.43848V4.31348C2.53125 3.74629 2.99531 3.28223 3.5625 3.28223H5.20219L6.23344 2.25098H3.5625C2.42812 2.25098 1.5 3.1791 1.5 4.31348V8.43848C1.5 9.57285 2.42812 10.501 3.5625 10.501H7.6875C8.82188 10.501 9.75 9.57285 9.75 8.43848V5.76754L8.71875 6.79879V8.43848Z",
    fill: "#A9AFD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditGray);
export default __webpack_public_path__ + "static/media/icon_edit_gray.0623f5ecdfe31cf44b001f113a3813a8.svg";
export { ForwardRef as ReactComponent };